
import Vue from "vue";
export default Vue.extend({
  name: "CarouselCard",
  props: {
    miniCards: Array,
  },
});
